<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="width+'px'"
    @close="close"
  >
    <el-form ref="addForm" :model="addForm" :label-width="labelWidth+'px'" :rules="rules">
      <template v-for="(item,index) in formList">
        <el-form-item
          v-if="item.model==='datePicker'"
          :key="index"
          :ref="item.key"
          :label="item.label+'：'"
          :prop="item.key"
        >
          <el-date-picker
            v-model="addForm[item.key]"
            :placeholder="item.placeholder"
            :value-format="item.valueFormat || 'yyyy-MM-dd'"
            :type="item.type||'date'"
            style="width: 100%;"
            :disabled="item.disabled"
            :clearable="item.clearable || true"
            :style="{
              width:item.width||'100%'
            }"
          />
        </el-form-item>
        <el-form-item
          v-if="item.model==='text'"
          :key="index"
          :ref="item.key"
          :label="item.label+'：'"
          :prop="item.key"
        >
          <el-input
            v-model="addForm[item.key]"
            style="width: 100%;"
            :placeholder="item.placeholder"
            :type="item.type||'text'"
            :maxlength="item.max"
            :disabled="item.disabled"
            :rows="item.rows||4"
            :show-word-limit="item.type==='textarea'"
          />
        </el-form-item>

        <el-form-item
          v-if="item.model==='number'"
          :key="index"
          :ref="item.key"
          :label="item.label+'：'"
          :prop="item.key"
        >
          <el-input-number
            v-model="addForm[item.key]"
            style="width: 100%;"
            :precision="item.precision || 0"
            :disabled="item.disabled"
            :placeholder="item.placeholder"
            :min="item.min"
            :max="item.max"
          />
        </el-form-item>

        <el-form-item
          v-if="item.model==='select'"
          :key="index"
          :ref="item.key"
          :label="item.label+'：'"
          :prop="item.key"
        >
          <el-select v-model="addForm[item.key]" :disabled="item.disabled" :placeholder="item.placeholder" :multiple="item.multiple" style="width: 100%;">
            <el-option
              v-for="i in item.options"
              :key="i[item.props.value]"
              :label="i[item.props.label]"
              :value="i[item.props.value]"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="item.model==='upload'"
          :key="index"
          :ref="item.key"
          :label="item.label+'：'"
          :prop="item.key"
        >
          <um-upload
            v-model="addForm[item.key]"
            style="width: 100%;"
            :disabled="item.disabled"
            :limit="item.limit || 0"
            :tip="item.placeholder"
          />
        </el-form-item>
        <el-form-item
          v-if="item.model==='uploadImg'"
          :key="index"
          :ref="item.key"
          :label="item.label+'：'"
          :prop="item.key"
        >
          <um-upload-img
            v-model="addForm[item.key]"
            style="width: 100%;"
            :disabled="item.disabled"
            :limit="item.limit || 0"
            :is-cropper="item.cropper || false"
            :simple="item.simple || true"
            :cropper-options="item.cropperOptions"
            :placeholder="item.placeholder"
          />
        </el-form-item>

      </template>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deepClone } from '@/utils/index'
export default {
  name: 'UmForm',
  props: {
    // 标题
    title: {
      type: String,
      default: '标题'
    },
    // 表单配置项
    options: {
      type: Array,
      default: () => []
    },
    // 弹框宽度
    width: {
      type: Number,
      default: 600
    },
    // 组件label宽度
    labelWidth: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      // 表单数据
      addForm: {},
      // 是否显示
      visible: true,
      // 表单数据
      formList: [],
      // 校验规则
      rules: {}
    }
  },
  watch: {
    options: {
      handler(val) {
        val.map(item => {
          const rules = []
          if (item.required) {
            rules.push({ required: true, message: '必填项不能为空', trigger: ['change', 'blur'] })
          }
          if (item.min && item.model !== 'number') {
            rules.push({ min: item.min, message: `长度不能小于${item.min}个字符`, trigger: 'change' })
          }
          if (item.max && item.model !== 'number') {
            rules.push({ max: item.max, message: `长度不能大于${item.max}个字符`, trigger: 'change' })
          }
          this.rules[item.key] = rules
          // this.addForm[item.key] = item.value
          if (item.model === 'upload' && item.value === undefined) {
            this.$set(this.addForm, item.key, [])
          } else {
            this.$set(this.addForm, item.key, item.value)
          }
        })
        this.formList = deepClone(val)
      },
      immediate: true
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleAfterLeave() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el) // 可能移除的时候组件已经不存在了
    },
    // 关闭
    close() {
      this.$refs.addForm.resetFields()
      this.handleAfterLeave()
    },
    // 表单提交
    submit() {
      this.$refs.addForm.clearValidate()
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$emit('change', deepClone(this.addForm))
          // this.visible = false
        } else {
          this.$message.error('请填写正确的表单！')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
